var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-full flex flex-col"},[(_vm.user && _vm.user.id)?_c('GuestForm'):_c('div',{staticClass:"max-w-md mx-auto flex items-center justify-center min-h-screen"},[_c('loading-icon',{staticClass:"h-10 w-10 text-pink-500"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }